import { useState } from 'react';

import Breadcrumb from '../Pages/Breadcrumb';

import { useUserData } from '../../store/UserData';
import ProfileLoading from '../loading/profile';
import ProfileInfo from './Profile-data';
import EditProfile from './edit-profile';
import PasswordChange from './PasswrdChange';
import ServiceList from './ServiceList';
import PaymentList from './PaymetList';
import DeleteAccount from "./DeleteAccount";
import CourseCard from './CourseCard';
import PackageManager from './PackageManager';
import { useTranslation } from 'react-i18next';

const Profile = () => {
  const { t } = useTranslation();
  const { error, loading } = useUserData();
  const [activeTab, setActiveTab] = useState(0);

  const tabs = t('profile.tabs', { returnObjects: true });

  if (error) return <div className="h-dvh w-full flex justify-center items-center"><p>{error}</p></div>;
  if (loading) return <ProfileLoading editProfile={false} />;

  return (
    <>
      <Breadcrumb pages={[t('routes.profile')]} />
      <div className="container">
        <main className="row justify-content-between">

          {/* قسم التبويبات */}
          <section className="border py-2 rounded-xl col-lg-3 mb-3">
            <div className="tabs flex !gap-3 flex-col">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`py-2 px-4 text-start ${activeTab === index ? 'bg-primary-tw text-white border rounded-xl' : 'text-semi-gray border-b'
                    }`}
                  onClick={() => setActiveTab(index)}
                >
                  {tab}
                </button>
              ))}
            </div>
          </section>

          {/* قسم المحتوى الخاص بالتبويبات */}
          <section className="col-lg-8 border rounded-xl py-2">
            {activeTab === 0 && <PersonalInfoContent />}
            {activeTab === 1 && <ServicesContent />}
            {activeTab === 2 && <SubscriptionsContent />}
            {activeTab === 3 && <PackagesContent />}
            {activeTab === 4 && <PaymentMethodsContent />}
            {activeTab === 5 && <AccountSettingsContent />}
            {activeTab === 6 && <SecuritySettingsContent />}
            {activeTab === 7 && <DeleteAccountContent />}
          </section>

        </main>
      </div>
    </>
  );
};

// ** مكونات المحتوى لكل تبويب **
const PersonalInfoContent = () => (
  <div className="w-100">
    <ProfileInfo />
  </div>
);

const ServicesContent = () => (
  <div className="w-100">
    <ServiceList />
  </div>
);

const AccountSettingsContent = () => (
  <div className="w-100">
    <EditProfile />
  </div>
);

const SecuritySettingsContent = () => (
  <div className="w-100">
    <PasswordChange />
  </div>
);

const SubscriptionsContent = () => (
  <div className="w-100">
    {/* المحتوى الخاص بالكورسات */}
    <CourseCard />
  </div>
);

const PaymentMethodsContent = () => (
  <div className="w-100">
    <PaymentList />
  </div>
);

const PackagesContent = () => (
  <div className="w-100">
    <PackageManager />
  </div>
);
const DeleteAccountContent = () => (
  <div className="w-100">
    <DeleteAccount />
  </div>
);

export default Profile;
